'use client';

import IrisIcon from '@components/InternalIcons/Icons/IrisIcon/IrisIcon';
import CurrentStoreStockIcon from '@components/InternalIcons/Icons/StockIcons/CurrentStoreStockIcon';
import OnlineStockIcon from '@components/InternalIcons/Icons/StockIcons/OnlineStockIcon';
import StockInOtherLocationsIcon from '@components/InternalIcons/Icons/StockIcons/StockInOtherLocationsIcon';
import { getStockUrl } from '@components/InternalIcons/utils/getIconsUrls';
import type { Subsidiary } from '@coolblue-development/constants';
import { getStockData } from '@features/internal-icons/api/actions';
import { AvailableProductStockLevelsForStore } from '@features/internal-icons/typings/AvailableProductStockLevelsForStore';
import { AvailableProductStockLevelsForWebshop } from '@features/internal-icons/typings/AvailableProductStockLevelsForWebshop';
import { ReactElement, useEffect, useState } from 'react';

type Props = {
  productId: number;
  totalIndices: number;
  storeEmployee: boolean;
  subsidiary: Subsidiary;
};

export const StockIcons = ({
  productId,
  subsidiary,
  totalIndices,
  storeEmployee
}: Props): ReactElement => {
  const stockUrl = getStockUrl(productId, subsidiary);
  const [stockLevels, setStockLevels] = useState<
    AvailableProductStockLevelsForStore | AvailableProductStockLevelsForWebshop | null
  >(null);

  useEffect(() => {
    if (!productId) return;

    const fetchStockData = async () => {
      const stockLevels = await getStockData(productId);
      setStockLevels(stockLevels);
    };
    fetchStockData().catch(console.error);
  }, [productId]);

  if (!stockUrl) return <></>;

  return storeEmployee ? (
    <>
      <IrisIcon url={stockUrl.href} index={4} totalIndices={totalIndices} />
      <CurrentStoreStockIcon
        stockCount={
          (stockLevels as AvailableProductStockLevelsForStore)?.availableProductStockLevelInStore
        }
        url={stockUrl.href}
        index={5}
        totalIndices={totalIndices}
      />
      <OnlineStockIcon
        stockCount={
          (stockLevels as AvailableProductStockLevelsForStore)?.availableProductStockLevelWebshop
        }
        url={stockUrl.href}
        index={6}
        totalIndices={totalIndices}
      />
      <StockInOtherLocationsIcon
        stockCount={
          (stockLevels as AvailableProductStockLevelsForStore)
            ?.availableProductStockLevelOtherStores
        }
        url={stockUrl.href}
        index={7}
        totalIndices={totalIndices}
      />
    </>
  ) : (
    <>
      <IrisIcon url={stockUrl.href} index={4} totalIndices={totalIndices} />
      <OnlineStockIcon
        stockCount={
          (stockLevels as AvailableProductStockLevelsForWebshop)?.availableProductStockLevelWebshop
        }
        url={stockUrl.href}
        index={5}
        totalIndices={totalIndices}
      />
      <StockInOtherLocationsIcon
        stockCount={
          (stockLevels as AvailableProductStockLevelsForWebshop)?.availableProductStockLevelStores
        }
        url={stockUrl.href}
        index={6}
        totalIndices={totalIndices}
      />
    </>
  );
};

export default StockIcons;
